import { render, staticRenderFns } from "./ModuleContractInteract.vue?vue&type=template&id=a0506e28"
import script from "./ModuleContractInteract.vue?vue&type=script&lang=js"
export * from "./ModuleContractInteract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports